import { Inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { fetch } from '@ngrx/router-store/data-persistence';
import { map } from 'rxjs/operators';
import { ConceptQueries } from '.';
import { ConceptServiceInterface, CONCEPT_SERVICE_TOKEN } from '../../concept/concept.service.interface';
import { DalState } from '../dal.state.interface';
import { ConceptsActionTypes, ConceptsLoaded, ConceptsLoadError, LoadConcepts } from './concept.actions';

@Injectable()
export class ConceptEffects {
  loadConcepts$ = createEffect(() =>
    this.actions.pipe(
      ofType(ConceptsActionTypes.LoadConcepts),
      concatLatestFrom(() => this.store.select(ConceptQueries.getLoaded)),
      fetch({
        run: (action: LoadConcepts, loaded: boolean) => {
          if (!action.payload.force && loaded) return;
          return this.conceptService
            .getAllForUser(action.payload.userId)
            .pipe(map((concepts) => new ConceptsLoaded({ concepts })));
        },
        onError: (action: LoadConcepts, error) => {
          return new ConceptsLoadError(error);
        },
      })
    )
  );

  constructor(
    private actions: Actions,
    private store: Store<DalState>,
    @Inject(CONCEPT_SERVICE_TOKEN)
    private conceptService: ConceptServiceInterface
  ) {}
}
